import React, { useEffect, useState } from "react";

import { resendSignUpCode } from "aws-amplify/auth";
import i18n from "i18next";
import { Trans, useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { Button, Divider, Text, Title } from "@ui/elements";
import { Stack } from "@ui/layout";

import { OpenEmailButtons, toaster } from "@components";

export const ConfirmEmail = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [timer, setTimer] = useState(60);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const email = searchParams.get("email");

  useEffect(() => {
    let interval: NodeJS.Timer;
    if (isDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev > 0) {
            return prev - 1;
          } else {
            clearInterval(interval);
            setIsDisabled(false);
            return 0;
          }
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isDisabled]);

  const handleResendClick = async () => {
    setLoading(true);
    try {
      await resendSignUpCode({
        username: email as string,
        options: {
          clientMetadata: {
            locale: i18n.language,
            partnerId: process.env.REACT_APP_PARTNER_ID!,
          },
        },
      });

      toaster.success({
        title: t("messages.successful-verification-link-send"),
        message: t("messages.check-mailbox-verification-link"),
      });
    } catch (error) {
      let errorMessage: string;

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      errorMessage = String(error);

      toaster.warning({
        title: t("messages.failed-verification-link-send"),
        message: errorMessage,
      });
    } finally {
      setLoading(false);
      setTimer(60);
      setIsDisabled(true);
    }
  };

  return (
    <Stack direction="column" gap="md">
      <Stack direction="column" gap="xs">
        <Title size={5}>{t("verify-your-account")}</Title>
        <Text>
          <Trans
            i18nKey="check-your-mailbox"
            values={{ email: searchParams.get("email") }}
          />
        </Text>
      </Stack>
      <OpenEmailButtons />
      <Divider />
      <Stack justify="center" align="center">
        <Text variant="secondary" size="small">
          {t("not-received")}
        </Text>
        <Button
          size="small"
          variant="text"
          isLoading={loading}
          onClick={handleResendClick}
          disabled={isDisabled}
        >
          {isDisabled ? t("re-send-in", { seconds: timer }) : t("re-send")}
        </Button>
      </Stack>
    </Stack>
  );
};
